import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Project1 from "./pages/Project1";
import Project2 from "./pages/Project2";
import Project3 from "./pages/Project3";
import Project4 from "./pages/Project4";
import Project5 from "./pages/Project5";
import Project6 from "./pages/Project6";
import Project7 from "./pages/Project7";
import Project8 from "./pages/Project8";
import Project9 from "./pages/Project9";
import Project10 from "./pages/Project10";
import Project11 from "./pages/Project11";
import Project12 from "./pages/Project12";
import Project13 from "./pages/Project13";
import Project14 from "./pages/Project14";
import Project15 from "./pages/Project15";
import Project16 from "./pages/Project16";
import Project17 from "./pages/Project17";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import { AnimatePresence } from "framer-motion";
import PageProject1 from "./pages/PageProject1";
import PageProject2 from "./pages/PageProject2";
import PageProject3 from "./pages/PageProject3";
import PageProject4 from "./pages/PageProject4";
import PageProject5 from "./pages/PageProject5";
import PageProject6 from "./pages/PageProject6";
import PageProject7 from "./pages/PageProject7";
import PageProject8 from "./pages/PageProject8";
import PageProject9 from "./pages/PageProject9";
import PageProject10 from "./pages/PageProject10";
import PageProject11 from "./pages/PageProject11";
import PageProject12 from "./pages/PageProject12";
import PageProject13 from "./pages/PageProject13";
import PageProject14 from "./pages/PageProject14";
import PageProject15 from "./pages/PageProject15";
import PageProject16 from "./pages/PageProject16";
import PageProject17 from "./pages/PageProject17";

// J'ai installé framer-motion de (https://www.framer.com/motion/)
// Pour animer des éléments avec, je dois les englober d'une balise AnimatePresence. J'englobe donc toutes les routes de mon App dedans
// Ensuite, lorsque je souhaiterai animer quelque chose, je devrais indiquer "motion" devant
const App = () => {
  return (
    <BrowserRouter>
      <AnimatePresence>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/cameleon" element={<Project1 />} />
          <Route path="/bulles" element={<Project2 />} />
          <Route path="/to-do-list" element={<Project3 />} />
          <Route path="/minuteur" element={<Project4 />} />
          <Route path="/vacances" element={<Project5 />} />
          <Route path="/pays-du-monde" element={<Project6 />} />
          <Route path="/quiz" element={<Project7 />} />
          <Route path="/flappy-bat" element={<Project8 />} />
          <Route path="/actus-rh" element={<Project9 />} />
          <Route path="/visuels-com" element={<Project10 />} />
          <Route path="/logos" element={<Project11 />} />
          <Route path="/bandes-dessinees" element={<Project12 />} />
          <Route path="/editions-jeunesse" element={<Project13 />} />
          <Route path="/pochettes-disques" element={<Project14 />} />
          <Route path="/sweat-shirts" element={<Project15 />} />
          <Route path="/planches-skate" element={<Project16 />} />
          <Route path="/aeronautique" element={<Project17 />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/projet-cameleon" element={<PageProject1 />} />
          <Route path="/projet-bulles" element={<PageProject2 />} />
          <Route path="/projet-to-do-list" element={<PageProject3 />} />
          <Route path="/projet-minuteur" element={<PageProject4 />} />
          <Route path="/projet-vacances" element={<PageProject5 />} />
          <Route path="/projet-pays-du-monde" element={<PageProject6 />} />
          <Route path="/projet-quiz" element={<PageProject7 />} />
          <Route path="/projet-flappy-bat" element={<PageProject8 />} />
          <Route path="/projet-actu-rh" element={<PageProject9 />} />
          <Route path="/projet-visuel-com" element={<PageProject10 />} />
          <Route path="/projet-logos" element={<PageProject11 />} />
          <Route path="/projet-bandes-dessinees" element={<PageProject12 />} />
          <Route path="/projet-editions-jeunesse" element={<PageProject13 />} />
          <Route path="/projet-pochettes-disques" element={<PageProject14 />} />
          <Route path="/projet-sweat-shirts" element={<PageProject15 />} />
          <Route path="/projet-planches-skate" element={<PageProject16 />} />
          <Route path="/projet-aeronautique" element={<PageProject17 />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AnimatePresence>
    </BrowserRouter>
  );
};

export default App;
